/**
 *
 * RouteMarkers
 *
 */

import React from 'react';
import { compose } from 'redux';
import { withLeaflet } from 'react-leaflet';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import withRest from 'containers/Rest/withRest';
import withRoutes from 'containers/Routes/withEntity';
import withUiControl from 'containers/UiControl/withUiControl';
import minWidth from 'utils/minWidth';
import RouteMarker from './RouteMarker';

const UI_PARAMS = [
  'showRoutes',
  'onlyOwnRoutes',
  'distanceFilter',
  'routesMin',
  'routesMax',
];
/* eslint-disable react/prefer-stateless-function */
class RouteMarkers extends React.PureComponent {
  constructor(props) {
    super(props);
    this.loadRoutes = debounce(this.loadRoutes, 500).bind(this);
  }

  componentDidMount() {
    const { leaflet } = this.props;
    this.loadRoutes();
    leaflet.map.on('moveend', this.loadRoutes);
  }

  componentWillUnmount() {
    const { leaflet } = this.props;
    leaflet.map.off('moveend', this.loadRoutes);
  }

  componentDidUpdate(prevProps) {
    const { showRoutes } = this.props;
    if (!showRoutes) {
      return;
    }
    if (UI_PARAMS.some(par => this.props[par] !== prevProps[par])) {
      this.loadRoutes();
    }
  }

  loadRoutes() {
    const {
      apiList,
      leaflet,
      showRoutes,
      onlyOwnRoutes,
      distanceFilter,
      routesMin,
      routesMax,
    } = this.props;
    if (showRoutes) {
      const filter = minWidth() && distanceFilter;
      const min = filter ? routesMin : 0;
      const max = filter ? routesMax : 999999;
      apiList({
        bounds: leaflet.map.getBounds().toBBoxString(),
        select: onlyOwnRoutes ? 'own' : 'all',
        min,
        max,
      });
    }
  }

  render() {
    const { routes, showRoutes, params } = this.props;
    if (
      window.location.hash === '#routes' ||
      !showRoutes ||
      !routes.list ||
      routes.list.length === 0
    ) {
      return null;
    }
    const dimmed = Boolean(params.routeId || params.clubId);
    return (
      <React.Fragment>
        {routes.list.map(id => (
          <RouteMarker key={id} dimmed={dimmed} route={routes[id]} />
        ))}
      </React.Fragment>
    );
  }
}

RouteMarkers.propTypes = {
  apiList: PropTypes.func.isRequired,
  routes: PropTypes.object,
  params: PropTypes.object,
  onlyOwnRoutes: PropTypes.bool,
  distanceFilter: PropTypes.bool,
  showRoutes: PropTypes.bool,
  routesMin: PropTypes.number,
  routesMax: PropTypes.number,
  leaflet: PropTypes.object.isRequired,
};

export default compose(
  withRoutes,
  withRest,
  withLeaflet,
  withUiControl(UI_PARAMS),
)(RouteMarkers);
